
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M18 3H2V21H18V3Z"></path><path d="M19.5 7L23 8.5L19.5 19"></path><path d="M5 17.5455L12.4242 10.2727L15 17.5455H10.1515H5Z"></path><path d="M8.04547 9.54544C8.8739 9.54544 9.54547 8.87387 9.54547 8.04544C9.54547 7.21701 8.8739 6.54544 8.04547 6.54544C7.21704 6.54544 6.54547 7.21701 6.54547 8.04544C6.54547 8.87387 7.21704 9.54544 8.04547 9.54544Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiImages",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
